// import device from './_device.js';

export default () => {

  // let device = device();
  function device(){
    let device = 'pc';
    let w = $(window).width();
    if( w <= 750 ){
      device = 'sp';
    } else {
      device = 'pc';
    }
    return device;
  }

  // if(device==='pc'){
    window.addEventListener('load', () => {
      toggleHeadeerClass()
    }, false);
    window.addEventListener('scroll', () => {
      toggleHeadeerClass()
    }, false);
  // } else {
  //   const spWrapper = document.getElementById('skrollr-body')
  //   // spWrapper.addEventListener('load', () => {
  //   //   toggleHeadeerClassSp()
  //   // }, false);
  //   spWrapper.onscroll = (event) => {
  //     console.log('aaaaaa')
  //     toggleHeadeerClassSp()
  //   };
  // }

  const toggleHeadeerClass = () => {
    if(window.scrollY>50){
      $('body').addClass('is-scroll')
      $('.l-header').addClass('is-scroll')
    } else {
      $('body').removeClass('is-scroll')
      $('.l-header').removeClass('is-scroll')
    }
  }
  const toggleHeadeerClassSp = () => {
    const spWrapper = document.getElementById('skrollr-body')
    if(spWrapper.scrollY>50){
      $('body').addClass('is-scroll')
      $('.l-header').addClass('is-scroll')
    } else {
      $('body').removeClass('is-scroll')
      $('.l-header').removeClass('is-scroll')
    }
  }
}